export const windowEvents = {
  dispatchCustom: (name: string, detail?: unknown) => {
    try {
      const event = new CustomEvent(name, { detail });
      self?.dispatchEvent?.(event);
    } catch (er) {
      console.error(er);
    }
  },
};
